import { Timeschedule, useFetchTimeschedulesQuery } from "../../../../../store/api/TimescheduleApi";
import Autocomplete from "@mui/material/Autocomplete";
import { AutocompleteProps, TextField } from "@mui/material";
import React, { useState } from "react";

export function TimescheduleAutocomplete({
  salesarea_id,
  onChange,
  allowAlwaysActive,
  ...autocompleteProps
}: { salesarea_id: number; allowAlwaysActive?: boolean } & Omit<
  AutocompleteProps<Timeschedule, undefined, undefined, undefined>,
  "multiple" | "options" | "renderInput"
>) {
  const [value, setValue] = useState<Timeschedule>();
  const { data, isLoading, isFetching } = useFetchTimeschedulesQuery({
    salesarea_id,
  });

  const options = data?.data ?? [];

  return (
    <Autocomplete<Timeschedule, undefined, undefined, undefined>
      getOptionLabel={(timeschedule) => {
        return timeschedule.name;
      }}
      loading={isLoading}
      onChange={onChange}
      options={allowAlwaysActive ? [...options, { label: "All opening hours", value: "ALWAYS" }] : options}
      renderInput={(params) => <TextField {...params} label={"Timeschedule"} />}
      {...autocompleteProps}
    />
  );
}
